export default __webpack_public_path__ + "static/media/icone link.3fadec0d.svg";